import React from 'react'

import Header from './fheader'
import Footer from './footer'

export default ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
  </>
)
